import { StepProps } from "antd/lib";
import { FC, useMemo } from "react";
import { SubtaskAssortmentMatrix } from "tm-shared/types";

import { ASSORTMENT_SUBTASK_ICON } from "@/constants";

import { StyledSteps, StyledStepsContainer } from "./Styled";

interface StepsSectionProps {
    subtasks: SubtaskAssortmentMatrix[];
    currentStep: number;
    onStepChange: (stepKey: number) => void;
}

export const StepsSection: FC<StepsSectionProps> = ({
    subtasks,
    currentStep,
    onStepChange,
}) => {
    const steps: StepProps[] = useMemo(() => {
        return subtasks.map((s, index) => {
            const { subtaskId, type } = s;

            let status = "wait";

            if (index === currentStep) {
                status = "process";
            }

            const Icon = ASSORTMENT_SUBTASK_ICON[type];

            return {
                key: subtaskId,
                status: status as StepProps["status"],
                icon: <Icon style={{ fontSize: 16 }} />,
            };
        });
    }, [subtasks, currentStep]);

    return (
        <StyledStepsContainer>
            <StyledSteps
                direction="horizontal"
                size="small"
                responsive={false}
                current={currentStep}
                onChange={onStepChange}
                items={steps}
            />
        </StyledStepsContainer>
    );
};
